
<vb-rating [templateClass]="styles.ratingStar">
	<rating [ngClass]="styles.rating" [(ngModel)]="rating" [readonly]="isReadOnly" (click)="onRatingClick()" (keydown.enter)="onRatingClick()"></rating>
</vb-rating>

<span *ngIf="ratingCount" [ngClass]="styles.ratingCount">
	{{ratingCount}}
</span>
